import React, {useState} from "react";
import {useParams} from "react-router-dom";
import {
    izvjestajPremaLokacijiTrake, izvjestajTrakaGreskaLokacije, izvjestajTrakaGreskaTezina, popraviLokacijeRedaRolni,
    popraviLokacijeRedaTraka
} from "../../api/inventure";
import notifyToast from "../../components/Toast/Toast";
import {ToastContainer} from "react-toastify";
import {KTIcon} from "../../../_websoft/helpers";
import moments from "moment/moment";
import LokacijeRsTraka from "../../components/LokacijeRSTraka/LokacijeRsTraka";
import {Table} from "../../models/Table";

type GreskaLokacijeRow = {
    Id: number
    InventuraId: number
    RolnaId: number | null
    TrakaId: number | null
    Lokacija: string | null
    SkeniranaLokacija: string | null
    SkeniranaLokacijaRed: string | null
    Tezina: string | null
    SkeniranaTezina: string | null
    Kreirano: string // ISO date
    traka:Table
}
type RolneMap = Record<string | number, number>;
const IzvjestajRedaTrake:React.FC = () => {
    const [loading, setLoading] = useState(false)

    const {id} = useParams()
    const IdFromURL = Number(id)
    const [izvjestajLokacije, setIzvjestajLokacije] = useState('');
    const [errors, setErrors] = useState('');
    const [touched, setTouched] = useState(false);

    const [lokacijaRolne, setLokacijaRolne] = useState('');

    const [greskeRows, setGreskeRows] = useState<GreskaLokacijeRow[]>([])
    const [greskeLoading, setGreskeLoading] = useState<boolean>(false)
    const [greskeError, setGreskeError] = useState<string>('')

    const [greskeRowsTezina, setGreskeRowsTezina] = useState<GreskaLokacijeRow[]>([])
    const [greskeLoadingTezina, setGreskeLoadingTezina] = useState<boolean>(false)
    const [greskeErrorTezina, setGreskeErrorTezina] = useState<string>('')
    const handleChange = async (value: string) => {
        setLokacijaRolne(value)

        const data = {
            lokacija: value,
            idInventure: IdFromURL,
        }

        // optional: clear previous results immediately to avoid flicker/old data
        setGreskeRows([])
        setGreskeRowsTezina([])
        setGreskeError('')
        setGreskeErrorTezina('')
        setLoading(true)

        try {
            // (Nice to fetch in parallel)
            const [response, resLok, resTez] = await Promise.all([
                izvjestajPremaLokacijiTrake(data),
                izvjestajTrakaGreskaLokacije(data),
                izvjestajTrakaGreskaTezina(data),
            ])

            // Lokacije table
            if (resLok?.success && Array.isArray(resLok.data)) {
                setGreskeRows(resLok.data as GreskaLokacijeRow[])
            } else {
                setGreskeRows([])
                setGreskeError(resLok?.message || 'Nepoznata greška')
            }

            // Težine table — fixed
            if (resTez?.success && Array.isArray(resTez.data)) {
                setGreskeRowsTezina(resTez.data as GreskaLokacijeRow[])
            } else {
                setGreskeRowsTezina([])
                setGreskeErrorTezina(resTez?.message || 'Nepoznata greška')
            }

            setIzvjestajLokacije(response)
        } catch (error) {
            console.error('Fetching error:', error)
        } finally {
            setLoading(false)
        }
    }


    const formatData = () => {
        // Check if izvjestajLokacije is an object and has keys
        if (izvjestajLokacije && Object.keys(izvjestajLokacije).length > 0) {
            const values = Object.values(izvjestajLokacije).map(value => +value);  // Convert all values to numbers
            const maxRollNumber = Math.max(...values); // Finds the maximum value
            return `Trake nisu pronadjene: ${values.join(', ')}`;
        }

        return "No valid data available.";
    };

    const popraviLokaciju = async () => {
        // Ensure these are in the right shapes
        const rolneSaGreskomRaw = izvjestajLokacije;         // could be array or object
        const odabranaLokacija = String(lokacijaRolne || '').trim();
        const idInventureNum = Number(IdFromURL);

        // Normalize rolneSaGreskom to a map { index: ReprMatId }
        const rolneSaGreskom: RolneMap = Array.isArray(rolneSaGreskomRaw)
            ? Object.fromEntries(
                rolneSaGreskomRaw
                    .filter((v): v is number => v != null && !isNaN(Number(v)))
                    .map((v, i) => [i, Number(v)])
            )
            : Object.fromEntries(
                Object.entries(rolneSaGreskomRaw || {})
                    .filter(([, v]) => v != null)
                    .map(([k, v]) => [k, Number(v)])
            );

        // Basic client-side validation (optional but helpful)
        if (!idInventureNum || !odabranaLokacija) {
            notifyToast(true, 'Nedostaju obavezna polja: inventura ili lokacija.');
            return;
        }


        const data = {
            idInventure: idInventureNum,
            odabranaLokacijaRolne: odabranaLokacija,
            rolneNisuPronadjene: rolneSaGreskom,
        };

        setLoading(true);
        try {
            // If your API needs auth, pass token: popraviLokacijeRedaRolni(data, token)
            const response = await popraviLokacijeRedaTraka(data);

            // Adjust to your API shape; earlier we returned { ok: boolean, msg: string }
            if (response.error === 0) {
                notifyToast(true, response.msg || 'Uspješno ažurirano.');
            } else {
                notifyToast(true, response?.msg || 'Došlo je do greške.');
            }
        } catch (err: any) {
            console.error('Fetching error:', err);
            const apiMsg =
                err?.response?.data?.message ||
                err?.message ||
                'Greška prilikom komunikacije sa serverom.';
            notifyToast(true, apiMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='row'>
                <ToastContainer/>
                <div className='col-8'>
                    <div className='card mb-5 mb-xl-10'>
                        <div
                            className='card-header border-0 cursor-pointer'
                            role='button'
                            data-bs-target='#kt_account_profile_details'
                            aria-expanded='true'
                            aria-controls='kt_account_profile_details'
                        >
                            <div className='card-title m-0'>
                                <h2>#{IdFromURL} Inventura reda trake</h2>
                            </div>
                        </div>

                        <div id='kt_account_profile_details' className='collapse show'>
                            <div className='card-body border-top p-9'>
                                <div className="row mb-5">
                                    <div className="col-5">
                                        <label>Odaberi lokaciju trake</label>
                                        <div className='col-lg-12 fv-row'>
                                            <LokacijeRsTraka
                                                value={lokacijaRolne}
                                                onChange={(name, value) => handleChange(value)}
                                                errors={errors}
                                                touched={touched}
                                                selectName='LokacijaRolne'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='separator'></div>
                                <div className='row mt-5'>
                                    <div className="col-12 mt-5">
                                        <h3>
                                            {formatData()}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-4'>
                    <div className='row'>
                        <div className="col-5 offset-lg-1 mt-4">
                            <button type='button' className='btn btn-primary' onClick={popraviLokaciju}>
                                <KTIcon iconName='plus' className='fs-2'/>
                                Popravi lokaciju
                            </button>
                        </div>
                        <div className="col-5 mt-4">
                            {/* <button type='button' className='btn btn-danger'>
                                <KTIcon iconName='minus' className='fs-2'/>
                                Greske tezine print
                            </button>*/}
                        </div>
                        <div className="col-12 mt-4">
                            <div className='alert alert-danger mt-4'>
                                <h3>
                                    NAPOMENA: Popravka lokacija dozvoljena je tek nakon što su sve greške u težinama ispravljene.
                                    <br/> <br/>U suprotnom, može doći do naknadnih sistemskih grešaka i netačnih prikaza inventure.
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-6'>
                    <div className='card mb-5 mb-xl-10'>
                        <div
                            className='card-header border-0 cursor-pointer'
                            role='button'
                            data-bs-target='#kt_account_profile_details'
                            aria-expanded='true'
                            aria-controls='kt_account_profile_details'
                        >
                            <div className='card-title p-2'>
                                <h2>#{IdFromURL} TRAKE - Greske lokacije <span className='text-primary'>{lokacijaRolne}</span></h2>
                            </div>
                            {!greskeLoading && !greskeError && greskeRows.length > 0 && (
                                <div className='table-responsive'>
                                    <table className='table table-bordered align-middle mt-5'>
                                        <thead>
                                        <tr className='bg-primary'>
                                            <th style={{width: 110}}>Rolna #</th>
                                            <th>Lokacija</th>
                                            <th>Skenirana Lokacija</th>
                                            <th>Lokacija nakon popravke</th>
                                            <th style={{width: 180}}>Kreirano</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {greskeRows.map((row) => (
                                            <tr key={row.Id}>
                                                <td>{row.TrakaId ?? ''}</td>
                                                <td>{row.Lokacija ?? ''}</td>
                                                <td>{row.SkeniranaLokacija ?? ''}</td>
                                                <td>{row.traka?.Lokacija ?? ''}</td>
                                                <td>{moments(row.Kreirano).format('DD-MM-YYYY HH:mm')}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
                <div className='col-6'>
                    <div className='card mb-5 mb-xl-10'>
                        <div
                            className='card-header border-0 cursor-pointer'
                            role='button'
                            data-bs-target='#kt_account_profile_details'
                            aria-expanded='true'
                            aria-controls='kt_account_profile_details'
                        >
                            <div className='col-12 card-title p-2'>
                                <h2>#{IdFromURL} TRAKE - Greske tezine <span className='text-primary'>{lokacijaRolne}</span></h2>
                            </div>
                            {!greskeLoadingTezina && !greskeErrorTezina && greskeRowsTezina.length > 0 && (
                                <div className='table-responsive'>
                                    <table className='table table-bordered align-middle mt-5'>
                                        <thead>
                                        <tr className='bg-primary'>
                                            <th style={{width: 110}}>RolnaId</th>
                                            <th>Skenirana Lokacija</th>
                                            <th>Tezina</th>
                                            <th>Skenirana Tezina</th>
                                            <th style={{width: 180}}>Kreirano</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {greskeRowsTezina.map((row) => (
                                            <tr key={row.Id}>
                                                <td>{row.TrakaId ?? ''}</td>
                                                <td>{row.Lokacija ?? ''}</td>
                                                <td>{row.Tezina ?? ''}</td>
                                                <td>{row.SkeniranaTezina ?? ''}</td>
                                                <td>{moments(row.Kreirano).format('DD-MM-YYYY HH:mm')}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default IzvjestajRedaTrake;
